// extracted by mini-css-extract-plugin
module.exports = {"Banner":"member-operations__SwitchSearchBanner__Banner","BannerButton":"member-operations__SwitchSearchBanner__BannerButton"};